import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { GaService } from 'src/app/core/helpers/ga.service';
import { NavigationEnd, Router } from '@angular/router';


@Component({
  selector: 'loyaltic-rewards-list',
  templateUrl: './rewards-list.component.html',
  styleUrls: ['./rewards-list.component.scss']
})
export class RewardsListComponent implements OnInit {
  readonly fallbackImageUrl = 'https://assets.qnordicsgames.com/image/upload/v1776693241/SWEFAZTUTTI26/logo-tutti-frutti.png';
  readonly rewardImageKeys = ['mainImageUrl', 'smallImageUrl', 'smallImageOverlayUrl', 'partnerLogo'];
  readonly swipeThresholdPx = 40;

  userId = '';
  userType = '';
  rewards = [];
  results ;
  culture = '';
  isLoggedIn = false;
  currentPage = '';
  orderSize: any[] = [];
  notifyToggleSaving: { [rewardPartitionKey: string]: boolean } = {};


  @ViewChild('captureAddress', { static: false }) captureAddressPopUpRef: any;
  @ViewChild('rewardDetailsModal', { static: false }) rewardDetailsModalRef: any;
  public modalRef: BsModalRef;
  popupConfig = {
    ignoreBackdropClick: true,
    class: 'modal-lg modal-order modal-dialog-centered',
  };

  rewardDetails: any;
  selectedReward: any;

  constructor(private coreService: CoreService, private authService: AuthService,
    private modalService: BsModalService, private translate: TranslateService, private toast: ToastrService,
    private router: Router, private gaService: GaService) {
    this.userId = authService.getUserId();
    this.userType = authService.getUserType();
    this.culture = translate.getDefaultLang();
    this.isLoggedIn = authService.IsLoggedIn()
  }

  ngOnInit() {
    this.getRewards();
    this.currentPage = this.router.url;
    //console.log(this.currentPage);

  }

  getRewards() {
    this.coreService.getRewards(this.culture, this.userId).then((response: any) => {
      this.results = response.result;
      this.rewards = response.result.rewards;
      this.orderSize = response.result.rewardSizes;
       this.rewards.map((reward:any) => {
        if (this.hasMultiplesizes(reward.partitionKey)) {
          reward.selectedSize = '';
        }

        reward.imageCarouselIndex = 0;
      })

      // console.log(this.rewards);
    });
  }

  getRewardImages(reward: any) {
    if (!reward) {
      return [];
    }

    return this.rewardImageKeys
      .map((key) => reward[key])
      .filter((imageUrl, index, imageUrls) => !!imageUrl && imageUrls.indexOf(imageUrl) === index);
  }

  getCurrentRewardImage(reward: any) {
    const images = this.getRewardImages(reward);

    if (!images.length) {
      return this.fallbackImageUrl;
    }

    const currentIndex = reward.imageCarouselIndex || 0;
    return images[currentIndex] || images[0];
  }

  getRewardCarouselImages(reward: any) {
    const images = this.getRewardImages(reward);
    return images.length ? images : [this.fallbackImageUrl];
  }

  showRewardImage(reward: any, direction: number, event: Event) {
    event.preventDefault();
    event.stopPropagation();

    this.moveRewardImage(reward, direction);
  }

  moveRewardImage(reward: any, direction: number) {
    const images = this.getRewardImages(reward);

    if (images.length <= 1) {
      return;
    }

    const currentIndex = reward.imageCarouselIndex || 0;
    reward.imageCarouselIndex = (currentIndex + direction + images.length) % images.length;
  }

  onRewardImageTouchStart(reward: any, event: TouchEvent) {
    if (this.getRewardImages(reward).length <= 1 || event.touches.length !== 1) {
      return;
    }

    reward.touchStartX = event.touches[0].clientX;
    reward.touchCurrentX = reward.touchStartX;
    reward.preventImageClick = false;
  }

  onRewardImageTouchMove(reward: any, event: TouchEvent) {
    if (reward.touchStartX === undefined || event.touches.length !== 1) {
      return;
    }

    reward.touchCurrentX = event.touches[0].clientX;

    if (Math.abs(reward.touchCurrentX - reward.touchStartX) >= this.swipeThresholdPx) {
      reward.preventImageClick = true;
    }
  }

  onRewardImageTouchEnd(reward: any, event: TouchEvent) {
    if (reward.touchStartX === undefined || reward.touchCurrentX === undefined) {
      this.resetRewardImageTouch(reward);
      return;
    }

    const deltaX = reward.touchCurrentX - reward.touchStartX;

    if (Math.abs(deltaX) >= this.swipeThresholdPx) {
      event.preventDefault();
      event.stopPropagation();
      reward.preventImageClick = true;
      this.moveRewardImage(reward, deltaX < 0 ? 1 : -1);
      this.resetRewardImageTouch(reward, true);
      return;
    }

    this.resetRewardImageTouch(reward);
  }

  onRewardImageTouchCancel(reward: any) {
    this.resetRewardImageTouch(reward);
  }

  onRewardCarouselImageClick(reward: any, event: Event) {
    if (reward.preventImageClick) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    this.openRewardDetails(reward);
  }

  onRewardImageError(event: Event) {
    const image = event.target as HTMLImageElement;

    if (image.src !== this.fallbackImageUrl) {
      image.src = this.fallbackImageUrl;
    }
  }

  resetRewardImageTouch(reward: any, keepClickBlocked = false) {
    reward.touchStartX = undefined;
    reward.touchCurrentX = undefined;

    if (!keepClickBlocked) {
      reward.preventImageClick = false;
      return;
    }

    setTimeout(() => {
      reward.preventImageClick = false;
    }, 300);
  }

   getSizeValue(partitionKey:string, selectedSize:string) {
    if (selectedSize === '') {
      let rewardLeft = 0;
      let Sizes = this.orderSize.filter((size:any) => size.rewardPK === partitionKey)[0].sizes;
      Sizes.map((size:any) => {
        rewardLeft = rewardLeft + size.rewardLeft;
      })
      return rewardLeft;
    } else {
      let Sizes = this.orderSize.filter((size:any) => size.rewardPK === partitionKey)[0].sizes;
      return Sizes.filter((size:any) => size.size === selectedSize)[0] ? Sizes.filter((size:any) => size.size === selectedSize)[0].rewardLeft : 0;
    }
   
  }

  hasSize(sizeInput:string, sizeArray:any) {
    return sizeArray.filter((size:any) => size.size.trim() === sizeInput).length > 0;
  }

  hasMultiplesizes(partitionKey:string) {
    return this.orderSize.filter((size:any) => size.rewardPK === partitionKey).length > 0;
  }

  getRewardSizes(partitionKey:string) {
    return this.orderSize.filter((size:any) => size.rewardPK === partitionKey)[0].sizes;
  }

  getClassDetail(reward:any) {
    let todayDate = new Date();
    let parsedDate = new Date(Date.UTC(
      todayDate.getFullYear(),
      todayDate.getMonth(),
      todayDate.getDate(),
      todayDate.getHours(),
      todayDate.getMinutes(),
      todayDate.getSeconds()
    ));

    let rewardDate=  new Date(reward.activeTo);
    let parsedRewardDate= new Date(Date.UTC(
      rewardDate.getFullYear(),
      rewardDate.getMonth(),
      rewardDate.getDate(),
      rewardDate.getHours(),
      rewardDate.getMinutes(),
      rewardDate.getSeconds()
    ));

    let rewardDateFrom = new Date(reward.activeFrom);
    let parsedRewardDateFrom = new Date(Date.UTC(
      rewardDateFrom.getFullYear(),
      rewardDateFrom.getMonth(),
      rewardDateFrom.getDate(),
      rewardDateFrom.getHours(),
      rewardDateFrom.getMinutes(),
      rewardDateFrom.getSeconds()
    ));
    
    if (parsedDate > parsedRewardDate || parsedDate< parsedRewardDateFrom) {
      return 'inactive';
    } else {
      return 'active'
    }

  }

  onRedeemClick(reward) {
    this.rewardDetails = reward;
    this.modalRef = this.modalService.show(this.captureAddressPopUpRef, this.popupConfig);
  }

  openRewardDetails(reward) {
    this.selectedReward = reward;
    this.modalRef = this.modalService.show(this.rewardDetailsModalRef, {
      class: 'modal-dialog-centered'
    });
  }

  NotifyuserClick(RewardPartitionkey) {
    this.coreService.Notifyuser(this.userId, RewardPartitionkey)
      .then((response: any) => {
        const messageKey = response.messageKey;
        this.toast.success(this.translate.instant('' + messageKey), '');
        this.getRewards();
      });
  }

  isNotifyToggleSaving(rewardPartitionKey: string) {
    return !!this.notifyToggleSaving[rewardPartitionKey];
  }

  onNotifyToggle(rewardPartitionKey: string, event: Event, rewardMappingIndex: number) {
    const checkbox = event.target as HTMLInputElement;
    const nextIsNotified = checkbox.checked;
    const rewardMapping = this.results.rewardCSSMappings[rewardMappingIndex];
    const previousIsNotified = rewardMapping.isUserNotified;

    rewardMapping.isUserNotified = nextIsNotified;
    this.notifyToggleSaving[rewardPartitionKey] = true;

    this.coreService.updateRewardNotification(this.userId, rewardPartitionKey, nextIsNotified)
      .then((response: any) => {
        if (response && typeof response.isUserNotified === 'boolean') {
          rewardMapping.isUserNotified = response.isUserNotified;
          checkbox.checked = response.isUserNotified;
        }

        if (response && response.messageKey) {
          this.toast.success(this.translate.instant('' + response.messageKey), '');
        }
      })
      .catch(() => {
        rewardMapping.isUserNotified = previousIsNotified;
        checkbox.checked = previousIsNotified;
      })
      .then(() => {
        this.notifyToggleSaving[rewardPartitionKey] = false;
      });
  }


  onHideCaptureDetails() {
    this.modalRef.hide();
  }

}
